// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1G_5R","image":"Header_image__JyQTO","name":"Header_name__3T5dx","info":"Header_info__2RPUx","infoRow":"Header_infoRow__3ebHI"};